import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "preview",
  "use": "preview-usage",
  "viewBox": "0 0 56.42 61",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56.42 61\" id=\"preview\"><title>资源 41</title><g data-name=\"图层 2\"><path d=\"M11.44 11.5h30.5v3.81h-30.5zm-.1 7.66h30.5V23h-30.5zM3.81 3.81h45.75v30.5h3.81V3.81A3.81 3.81 0 0 0 49.56 0H3.81A3.81 3.81 0 0 0 0 3.81v53.38A3.81 3.81 0 0 0 3.81 61H30.5v-3.81H3.81zm7.6 30.6v3.81h9.27a13.34 13.34 0 0 1 .55-3.81zM27 26.79H11.34v3.81h11.59A13.42 13.42 0 0 1 27 26.79zm28.87 30.68l-8.74-8.64a13.33 13.33 0 1 0-2.88 2.51l8.93 8.82a1.91 1.91 0 1 0 2.7-2.7zm-28.4-17.34A9.53 9.53 0 1 1 37 49.67a9.53 9.53 0 0 1-9.53-9.53zm0 0\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/preview.svg
// module id = Zwwz
// module chunks = 6